module.exports = __webpack_public_path__ + "assets/img/148e2763f9b9b9742e53042b22d10d72.webp";